import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import _memoize from 'lodash/memoize';
import { FULL_HD, HD, KEYBOARD_OFFSET_X, KEYBOARD_OFFSET_Y } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { identity, middle } from '../../tornado/utils/sizes';
import {
  BACKGROUND_RADIUS,
  BAR_OPACITY,
  HEIGHT,
  TEXT_FONT,
  BAR_OFFSET_LEFT,
} from './customer/default/searchField.constants';

export const defaultContext = makeDefaultStylingContext();

export const WIDTH = {
  [HD]: 1050,
  [FULL_HD]: 1570,
};

export const OFFSET = {
  [HD]: 36,
  [FULL_HD]: 56,
};

export const BAR_PADDING_LEFT = BAR_OFFSET_LEFT;

export const colors = {
  bar: makeThemeColor(PRIMARY, BAR_OPACITY),
  background: makeThemeColor(TERTIARY),
  text_idle: makeThemeColor(PRIMARY, 0.6),
  text_completed: makeThemeColor(PRIMARY),
};

export const getInnerWidth = _memoize((width, padding) => width - padding * 2);

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    x: KEYBOARD_OFFSET_X[screenSize],
    y: KEYBOARD_OFFSET_Y[screenSize] - HEIGHT[screenSize] - OFFSET[screenSize],
    h: HEIGHT[screenSize],
    w: WIDTH[screenSize],
    clipping: true,
    Background: {
      rect: true,
      h: identity,
      w: identity,
      color: colors.background[colorMode],
      shader: {
        radius: BACKGROUND_RADIUS,
      },
    },
    Bar: {
      rect: true,
      h: identity,
      w: identity,
      color: colors.bar[colorMode],
      shader: {
        radius: BACKGROUND_RADIUS,
      },
    },
    Label: {
      x: BAR_PADDING_LEFT,
      mountY: 0.5,
      y: middle,
      text: {
        ...getFont(FONT[TEXT_FONT], screenSize),
        wordWrap: false,
        textColor: colors.text_idle[colorMode],
        verticalAlign: 'middle',
      },
    },
  };
};
